'use strict';
module.exports = require('./useconfirm.js');